import Ajv from 'ajv';
import { SentimentSchema, ReviewSchema } from './BrandRatingSchema';

export default class BrandRatingModel {

  constructor(sentimentData, reviewData) {

    this.sentimentData = sentimentData;
    this.reviewData = reviewData;

    this.errors = null;

    this.ajv = new Ajv();
    this.validateSentimentData(sentimentData);
    this.validateReviewData(reviewData);
    this.ajv = null;

  }

  get skuReviewCount() {
    return this.reviewData.reviews.TotalResults;
  }

  get totalReviewCount() {
    return this.sentimentData.reviewSentiments.TotalReviewCount;
  }

  get averageBrandRating() {
    return this.sentimentData.reviewSentiments.AverageBrandRating;
  }

  validateSentimentData(data) {
    const valid = this.ajv.validate(SentimentSchema, data);
    if (!valid) this.errors = this.ajv.errors;
  }

  validateReviewData(data) {
    const valid = this.ajv.validate(ReviewSchema, data);
    if (!valid) this.errors = this.ajv.errors;
  }

}
